import React from "react";
import {Formik, Field, Form} from "formik";
import {TextField, Loading, MultiSelect, Select, PersianDataPicker,} from "components/form";
import {required, validationWrapper, isUserName} from "lib/formValidations";
import {transformTranslateFromValues, transformTranslateServerValues, dateTimeToserver,} from "lib/helpers";
import Modal from "components/Modal";

export default function StoreDirectorProfile(props) {
   
   const {show, item} = props;

   return (
      <>
         <Modal show={props.show} handleClose={props.close} title={props.title}>
            <Formik
               initialValues={{
                  ...transformTranslateServerValues({
                     ...item?.director_profile
                  }),
               }}
               onSubmit={async (values, {setSubmitting}) => {
                  if (values.birthday)
                     values.birthday = dateTimeToserver(values.birthday, "YYYY-MM-DD");
                  await props.submit(transformTranslateFromValues(values), item.id);
                  props.close();
                  setSubmitting(false);
               }}
               enableReinitialize
            >
               {({isSubmitting, dirty,values}) => (
                  <Form>
                     <div className="modal-body gap-y-3">
                        <div className="intro-x grid md:grid-cols-2 md:gap-3">
                     <Field
                    placeholder="نام"
                    label="نام :"
                    name="first_name"
                    component={TextField}
                    validate={(value) => validationWrapper(value, required)}
                  />
                  <Field
                    placeholder="نام خانوادگی"
                    label="نام خانوادگی :"
                    name="last_name"
                    component={TextField}
                    validate={(value) => validationWrapper(value, required)}
                  />
                 
                  <Field
                     placeholder="شماره ملی"
                     label="شماره ملی :"
                     name="national_number"
                     component={TextField}
                     
                  />
                        <Field
                     placeholder="شماره قرارداد"
                     label="شماره قرارداد :"
                     name="contract_number"
                     component={TextField}
                     
                  />     
                
                  <div className="user-datepicker">
                     <Field
                        label="تاریخ شروع قرارداد :"
                        name="contract_start_date"
                        component={PersianDataPicker}
                     />
                  </div>

                  <Field
                     placeholder="شماره شبا"
                     label="شماره شبا :"
                     name="sheba_number"
                     component={TextField}
                   
                  />     
                           
                        </div>
                     </div>

                     <div className="modal-footer text-right">
                        <button
                           className="btn btn-primary w-20"
                           type="submit"
                           disabled={!!(isSubmitting || !dirty)}
                        >
                           {" "}
                           {isSubmitting ? <Loading/> : "ذخیره"}
                        </button>
                        <button
                           type="button"
                           disabled={isSubmitting}
                           onClick={props.close}
                           className="btn btn-outline-secondary w-20 mr-1 text-white"
                        >
                           انصراف
                        </button>
                     </div>
                  </Form>
               )}
            </Formik>
         </Modal>
      </>
   );
}
